import { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import ScrollToTop from './components/ScrollToTop';
import PageLoader from './components/PageLoader';
import { SiteConfigProvider } from './context/SiteConfigContext';
import { CampaignsProvider } from './context/CampaignsContext';
import { CookieConsentProvider } from './privacy/cookie/CookieConsentProvider';
import AnalyticsInit from './components/analytics/AnalyticsInit';

function App() {
  return (
    <SiteConfigProvider>
      <CampaignsProvider>
        <CookieConsentProvider>
          <AnalyticsInit />
          <BrowserRouter basename={__BASE_PATH__}>
            <ScrollToTop />
            <Suspense fallback={<PageLoader />}>
              <AppRoutes />
            </Suspense>
          </BrowserRouter>
        </CookieConsentProvider>
      </CampaignsProvider>
    </SiteConfigProvider>
  );
}

export default App;
